module.exports = __webpack_public_path__ + "img/border_shield.250545d5.svg";